import './App.css';
import { Suspense, lazy } from "react";
import { BrowserRouter as Router,  Routes, Route } from "react-router-dom";
import SidebarNavigation from './components/SidebarNavigation';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { featuresAppRoot, featuresDashboard } from './FeaturesConstants';


function App() {

const ManageFeatures = lazy(() =>
  import("./pages/ManageFeatures")
);

const UserSettingsPage = lazy(() =>
  import("./pages/UserSettingsPage")
);

const SessionReplaysPage = lazy(() =>
import("./pages/SessionReplaysPage")
);

const ValuesPage = lazy(() =>
  import("./pages/ValuesPage")
);

const ManageValuePage = lazy(() =>
  import("./pages/ManageValuePage")
);

const ManageUserSettingsPage = lazy(() =>
  import("./pages/ManageUserSettingsPage")
);

const ValuesCoordinateSchemaPage = lazy(() =>
  import("./pages/ValuesCoordinateSchemaPage")
);

const AccountPage = lazy(() =>
import("./pages/AccountPage")
);

const BillingPage = lazy(() =>
import("./pages/BillingPage")
);

const BillingUpgradeSuccessPage = lazy(() =>
import("./pages/BillingPageUpgrade")
);

const AppSumoRedeemPage = lazy(() =>
import("./pages/AppSumoRedeemPage")
);

const ApiTokensPage = lazy(() =>
import("./pages/ApiTokensPage")
);

const UsageGuidePage = lazy(() =>
import("./pages/UsageGuidePage")
);

const LoginPage = lazy(() =>
import("./pages/LoginPage")
);

const SignupPage = lazy(() =>
import("./pages/SignupPage")
);

const SupportPage = lazy(() =>
import("./pages/SupportPage")
);


// react query
const queryClient = new QueryClient();


  return (
    <QueryClientProvider client={queryClient}>
    <Router>
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path={featuresDashboard} element={<SidebarNavigation><ManageFeatures /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/values/:valueName`} element={<SidebarNavigation><ManageValuePage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/values`} element={<SidebarNavigation><ValuesPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/session-replays`} element={<SidebarNavigation><SessionReplaysPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/values-schemas`} element={<SidebarNavigation><ValuesCoordinateSchemaPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/user-settings/:valueName`} element={<SidebarNavigation><ManageUserSettingsPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/user-settings`} element={<SidebarNavigation><UserSettingsPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/api-tokens`} element={<SidebarNavigation><ApiTokensPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/account`} element={<SidebarNavigation><AccountPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/usage-guide`} element={<SidebarNavigation><UsageGuidePage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/support`} element={<SidebarNavigation><SupportPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/billing`} element={<SidebarNavigation><BillingPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/billing/upgrade-success/:sessionId`} element={<SidebarNavigation><BillingUpgradeSuccessPage /></SidebarNavigation>} />
          <Route path={`${featuresAppRoot}/billing/app-sumo-redeem`} element={<SidebarNavigation><AppSumoRedeemPage /></SidebarNavigation>} />

          <Route exact path={`${featuresAppRoot}/login`} element={<LoginPage />} />
          <Route exact path={`${featuresAppRoot}/signup`} element={<SignupPage />} />
          <Route exact path={""} element={<SignupPage />} />
        </Routes>
        
      </Suspense>
    </div>
    </Router>
    </QueryClientProvider>
  );
}

export default App;
